import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDiemKyHieuActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as any[], // Replace with the actual type if known
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as any | undefined, // Replace with the actual type if known
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as any, // Replace with the actual type if known
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eDiemKyHieuActionIds = generateActionTypeIds(eDiemKyHieuActionsObj, "DIEM_KY_HIEU");
export type IDiemKyHieuActionTypes = IGenericActionType<typeof eDiemKyHieuActionsObj, "DIEM_KY_HIEU">;